import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { SmallTagRounded } from '@/components/ui/Tag/SmallTagRounded';
import { HOTLINE_REQUEST_STATUS_SCHEDULING, HOTLINE_REQUEST_STATUS_SCHEDULED, HOTLINE_REQUEST_STATUS_COMPLETED, HOTLINE_REQUEST_STATUS_CANCELED, } from '@/feature/hotline/client/constant/requestStatus';
/** 表示設定 */
export const settings = {
    [HOTLINE_REQUEST_STATUS_SCHEDULING.value]: {
        color: 'lightBlue',
        text: HOTLINE_REQUEST_STATUS_SCHEDULING.label,
    },
    [HOTLINE_REQUEST_STATUS_SCHEDULED.value]: {
        color: 'lightOrange',
        text: HOTLINE_REQUEST_STATUS_SCHEDULED.label,
    },
    [HOTLINE_REQUEST_STATUS_COMPLETED.value]: {
        color: 'darkBlue',
        text: HOTLINE_REQUEST_STATUS_COMPLETED.label,
    },
    [HOTLINE_REQUEST_STATUS_CANCELED.value]: {
        color: 'allGray',
        text: HOTLINE_REQUEST_STATUS_CANCELED.label,
    },
};
/**
 * ホットライン相談申し込みのスタータス表示タグ
 */
export const HotlineClientRequestStatusTag = (props) => {
    const { className = '', status } = props;
    const { color, text } = settings[status];
    return (_jsx(SmallTagRounded, Object.assign({ className: className, color: color, size: 'sm' }, { children: text })));
};
